module.exports = __webpack_public_path__ + "img/17.4118bd94.jpg";